//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams, toCopy,getDate} from '@/utils/util.js'
import bottom from '@/assets/img/bottom.png'
import {uploadFile} from '@/utils/auth'
import footerNav from '@/components/footerNav'
import homeTip from '@/components/homeTip'
import {Dialog,Toast} from 'vant';

export default {
  name: "qualityOrderDetail",
  components: {
    footerNav,
    homeTip
  },
  computed: {
    okPercent(){
      if(this.basicForm.spotCheckTotalNum&&this.basicForm.goodTotalNum){
        return ((this.basicForm.goodTotalNum/this.basicForm.spotCheckTotalNum)*100).toFixed(2)
      }else{
        return 0
      }
    }
  },
  data() {
    return {
      toCopy,
      currentDate:new Date(),
      showPopup:false,
      list:[],
      list1:[],
      rowNow:0,
      bottom,
      qualityOrderTypeList:[],
      checkAll:false,
      sendTypeList:[],
      emsList:[],
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      basicForm: {
        sendOrderDetailList: [],
        computedList: [],
        purchaseOrderSn:'',
        firstDeptName:'',
        secondDeptName:'',
        supplierName:'',
        sendType:'1',
        driverName:'',
        driverPhone:'',
        expressNo:'',
        expressId:'',
        remark:'',
        sendOrderSn:'',
        deliveryOrderSn:'',
        sendOrderId:'',
        qualityOrderType:'',
        sendTotalCtn:'',
        sendTime:'',
        channelStr:'',
        crtUserName:'',
      },
      qualityOrderId: '',
      qualityResultId: '',
      qualityOrderTypeStr: '',
      sendTypeStr: '',
      expressStr: '',
      isSend: false,
      dataList: [],
      currentColorValue:'',
      currentSpuCode:'',
      pageType:1,
      currentIndex:'',
      centerList:[],
      sendOrderId:''
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.sendOrderId) {
      this.sendOrderId = this.$route.query.sendOrderId
    }
    this.queryOption()
    this.queryData()
  },
  methods: {
    numChange(i,key){
      this.list1[i][key]=this.list1[i][key].replace(/[^\d]/g, '')
    },
    checkMobile(val){
      if(val){
        return /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/.test(val)
      }else{
        return true
      }
    },
    hasBtn(id) {
      return this.$store.state.btnList.indexOf(id) != -1
    },
    queryData() {
      var queryParams = {
        sendOrderId:this.sendOrderId
      };
      axiosApi.querySendOrder(queryParams).then(response => {
        var data = response.content;
        if(data.sendType=='1'){
          this.sendTypeStr = "快运"
        }else{
          this.sendTypeStr = "自送"
        }
        if(data.expressName){
          this.expressStr = data.expressName
        }
        if(data.qualityOrderType=='1'){
          this.qualityOrderTypeStr = "抽检"
        }else if(data.qualityOrderType=='2'){
          this.qualityOrderTypeStr = "全检"
        }else{
          this.qualityOrderTypeStr = "免检"
        }
        if(data.sendTime){
          data.sendTime = data.sendTime.slice(0,10)
        }
        for (var ind in data) {
          var val = data[ind] != null ? data[ind] : ""
          this.$set(this.basicForm, ind, val)
        }
        var channelStr = '';
        if(this.basicForm.firstDeptName){
          channelStr+=this.basicForm.firstDeptName
        }
        if(this.basicForm.secondDeptName){
          channelStr+='/'+this.basicForm.secondDeptName
        }
        this.$set(this.basicForm, 'channelStr', channelStr)
        this.getSpecList()

      }).catch(error => {
      })
      var queryParams = {
        "sendOrderId":this.sendOrderId,
        // "spuCode":item.spuCode,
        // "colorCode":item.colorCode,
        // "spuCodeList":[this.arr[0].spuCode],
        "start":0,
        "size":30,
        "orderRules":[{"orderKey":"t1.spuCode","desc":false},{"orderKey":"t1.colorCode","desc":false}]
      };
      axiosApi.querySendOrderDetail(queryParams).then(response => {
        this.basicForm.sendOrderDetailList = response.content.list;
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    },
    getSpecList() {
      var queryParams = {
        "start":0,
        "size":50,
        "orderRules":[{"orderKey":"t1.spuCode","desc":false},{"orderKey":"t1.colorCode","desc":false}],
        "desc":true,
        "sendOrderId":this.sendOrderId
      };
      axiosApi.querySendOrderByColor(queryParams).then(response => {
        if(response.content&&response.content.list&&response.content.list.length>0){
          // response.content.list.forEach((item)=>{
          //   item.isEdit = true;
          // })
          this.basicForm.computedList = response.content.list
        }else{
          this.basicForm.computedList = []
        }
        this.queryAddList()
      }).catch(error => {
      })
    },
    queryOption(){
      var queryParams = {}
      axiosApi.baseExpress(queryParams).then(response => {
        var arr = []
        for (var ind in response.content) {
          var item = response.content[ind]
          arr.push(
            {
              text: item.name,
              value: item.id
            }
          )
        }
        this.emsList = arr
      }).catch(error => {
      })
      var queryParams1 = {optionCode:'sendType'}
      axiosApi.getOptions(queryParams1).then(response => {
        var arr = []
        for (var ind in response.content) {
          var item = response.content[ind]
          arr.push(
            {
              text: item.name,
              value: item.code
            }
          )
        }
        this.sendTypeList = arr
      }).catch(error => {
      })
      var queryParams2 = {optionCode:'qualityOrderType'}
      axiosApi.getOptions(queryParams2).then(response => {
        var arr = []
        for (var ind in response.content) {
          var item = response.content[ind]
          arr.push(
            {
              text: item.name,
              value: item.code
            }
          )
        }
        this.qualityOrderTypeList = arr
      }).catch(error => {
      })
    },
    queryAddList(){
      var queryParams = {
        "purchaseOrderId":this.basicForm.purchaseOrderId,
        // "spuCodeList":[this.arr[0].spuCode],
        "start":0,
        "size":30,
        "orderRules":[{"orderKey":"t1.spuCode","desc":false},{"orderKey":"t1.colorCode","desc":false}]
      };
      axiosApi.queryDeliveryList(queryParams).then(response => {
        response.content.list.forEach((item)=>{
          if(this.basicForm.computedList.every((item1)=>{
            return item.spuCode!=item1.spuCode||item.colorValue!=item1.colorValue
          })){
            item.choose = false
          }else{
            item.choose = true
          }
        })
        this.list = response.content.list;
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    },
    searchAdd(){
      this.showPopup = true
    },
    toAddReason() {
      this.popType = 1;
      this.number= '';
      this.type = '一般';
      this.typeValue = 0;
      this.reason = '';
      this.showPopup = true
      // this.$router.push({name: 'addReason', type: 2})
    },
    afterRead(file) {
      this.canSubmit = false
      // console.log(file)
      // console.log(this.fileList)
      if (Array.isArray(file)) {
        for (var i in file) {
          uploadFile(file[i].file, 'file', url => {
            // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
            this.basicForm.attachedFile.push(url)
            if (i == (file.length - 1)) {
              this.canSubmit = true
            }
          });
        }
      } else {
        uploadFile(file.file, 'file', url => {
          // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
          this.basicForm.attachedFile.push(url)
          this.canSubmit = true
        });
      }
    },
    delImg(file, detail) {
      return new Promise((resolve, reject) => {
        this.basicForm.attachedFile.splice(detail.index, 1)
        resolve();
      });
    },
    totalChange(){
      var queryParams = {
        ...this.basicForm
      }
      axiosApi.updateQualityNum(queryParams).then(response => {
        var queryParams1 = {
          qualityOrderColorList: this.dataList
        };
        queryQualityOrderByColor(queryParams1).then(response => {
          var data = response.content;
          if (data.qualityOrderDetailList) {
            data.qualityOrderDetailList.forEach((item) => {
              item.isEdit = true
            })
          }
          this.basicForm.qualityOrderDetailList = data.qualityOrderDetailList
          var num = this.basicForm.spotCheckTotalNum
          if(this.basicForm.normalTotalNum){
            num-=parseInt(this.basicForm.normalTotalNum)
          }
          if(this.basicForm.badTotalNum){
            num-=parseInt(this.basicForm.badTotalNum)
          }
          this.basicForm.goodTotalNum=num
        }).catch(error => {
        })
      }).catch(error => {
      })
    },
    //
    chooseConfirm(){
      this.showPopup = false
    },
    deleteRow(item){
      for(var i = 0;i<this.basicForm.sendOrderDetailList.length;i++){
        if(this.basicForm.sendOrderDetailList[i].spuCode == item.spuCode&&this.basicForm.sendOrderDetailList[i].colorValue == item.colorValue){
          this.basicForm.sendOrderDetailList.splice(i,1)
          i--
        }
      }
      for(var i = 0;i<this.basicForm.computedList.length;i++){
        if(this.basicForm.computedList[i].spuCode == item.spuCode&&this.basicForm.computedList[i].colorValue == item.colorValue){
          this.basicForm.computedList.splice(i,1)
          i--
        }
      }
      for(var i = 0;i<this.list.length;i++){
        if(this.list[i].spuCode == item.spuCode&&this.list[i].colorValue == item.colorValue){
          this.list[i].choose = false
        }
      }
    },
    onConfirm(value) {
      this.qualityOrderTypeStr = value.text;
      this.basicForm.qualityOrderType = value.value;
      this.showPicker = false;
    },
    open() {
      this.showPicker = true
    },
    open1() {
      this.showPicker1 = true
    },
    open2() {
      this.showPicker2 = true
    },
    open3() {
      this.showPicker3 = true
    },
    onClose(){
      this.reason = '';
      this.badNumber = '';
      this.type = '';
    },
    onConfirm1(value){
      this.basicForm.sendTime = getDate(value)
      this.showPicker1 = false;
    },
    onConfirm2(value){
      this.sendTypeStr = value.text;
      this.basicForm.sendType = value.value;
      this.showPicker2 = false;
    },
    onConfirm3(value){
      this.expressStr = value.text;
      this.basicForm.expressId = value.value;
      this.showPicker3 = false;
    },
    checkNum(){
      var num1 = this.basicForm.normalTotalNum||0;
      var num2 = this.basicForm.badTotalNum||0;
      var num3 = 0;
      var num4 = 0;
      for(var i = 0;i<this.basicForm.qualityOrderResultDetailList.length;i++){
        if (this.basicForm.qualityOrderResultDetailList[i].noPassType=='0') {
          num3 += parseInt(this.basicForm.qualityOrderResultDetailList[i].num)
        }
        if (this.basicForm.qualityOrderResultDetailList[i].noPassType=='1') {
          num4 += parseInt(this.basicForm.qualityOrderResultDetailList[i].num)
        }
        // if(this.basicForm.qualityOrderResultDetailList[i].qualityResult!==0&&this.basicForm.qualityOrderResultDetailList[i].qualityResult!==1){
        //   this.$message.error('列表中是否合格不能为空')
        //   return false
        // }
      }
      // this.basicForm.qualityOrderResultDetailList.forEach((item)=>{
      //
      // })
      console.log(num1,num3)
      if (num1!=num3 ) {
        Toast.fail('一般不合格数不对应')
        return false
      }
      if (num2!=num4 ) {
        Toast.fail('严重不合格数不对应')
        return false
      }
      return true
    },
    getGood(){
      var num = this.basicForm.spotCheckTotalNum
      if(this.basicForm.normalTotalNum){
        num-=parseInt(this.basicForm.normalTotalNum)
      }
      if(this.basicForm.badTotalNum){
        num-=parseInt(this.basicForm.badTotalNum)
      }
      console.log(num)
      this.basicForm.goodTotalNum=num
      if(this.okPercent>=90){
        this.basicForm.qualityResult=1
        this.value = '是'
      }else{
        this.basicForm.qualityResult=0
        this.value = '否'
      }
      // if(this.basicForm.qualityOrderResultDetailList.filter((item)=>{return item.noPassType===0}).length==0&&parseInt(this.basicForm.normalTotalNum)>0){
      //   this.basicForm.qualityOrderResultDetailList.push({'reasonId': [], 'remark': '', 'num': this.basicForm.normalTotalNum, 'noPassType': 0,'colorCode':'','qualityResult':''})
      // }
      // if(this.basicForm.qualityOrderResultDetailList.filter((item)=>{return item.noPassType===1}).length==0&&parseInt(this.basicForm.badTotalNum)>0){
      //   this.basicForm.qualityOrderResultDetailList.push({'reasonId': [], 'remark': '', 'num': this.basicForm.badTotalNum, 'noPassType': 1,'colorCode':'','qualityResult':''})
      // }
    },
    save(type) {
      if(this.isSend)return
      this.isSend = true
      if(type==1){
        if(!this.checkNum()){
          this.isSend = false
          return
        }
        if(this.basicForm.qualityResult.toString()==""){
          Toast.fail('请选择是否合格');
          this.isSend = false
          return;
        }
        var num = 0
        var num1 = 0
        if(this.basicForm.goodTotalNum){
          num+=parseInt(this.basicForm.goodTotalNum)
        }
        if(this.basicForm.normalTotalNum){
          num+=parseInt(this.basicForm.normalTotalNum)
        }
        if(this.basicForm.badTotalNum){
          num+=parseInt(this.basicForm.badTotalNum)
        }
        if(this.basicForm.spotCheckTotalNum){
          num1 = parseInt(this.basicForm.spotCheckTotalNum)
        }
        if(num>num1){
          Toast.fail('合格数加不合格数不能大于抽检数');
          this.isSend = false
          return
        }
        var queryParams = {
          ...this.basicForm,
          qualityOrderStatus: type,
        }
        axiosApi.submitQualityOrder(queryParams).then(response => {
          this.basicForm.qualityResultId = response.content.qualityResultId
          this.isSend = false
          Toast.success('操作成功');
          if (type != 0) {
            this.$router.back(-1)
          }
        }).catch(error => {
          this.isSend = false
        })
      }
    },
    editRow(item,i){
      this.currentIndex = i
      this.currentSpuCode = item.spuCode
      this.currentColorValue = item.colorValue
      var queryParams = {
        "sendOrderId":this.basicForm.sendOrderId,
        "spuCode":item.spuCode,
        "colorCode":item.colorCode,
        // "spuCodeList":[this.arr[0].spuCode],
        "start":0,
        "size":30,
        "orderRules":[{"orderKey":"t1.spuCode","desc":false},{"orderKey":"t1.colorCode","desc":false}]
      };
      axiosApi.querySendOrderDetail(queryParams).then(response => {
        console.log(response.content.list)
        this.list1 = response.content.list;
        console.log(this.list1)
        this.pageType = 2
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    },
    // toDetail(item){
    //   if(!item.choose){
    //     this.$router.push({name:'createSendOrderDetail',query:{purchaseOrderId:this.basicForm.purchaseOrderId,spuCode:item.spuCode,colorCode:item.colorCode,colorValue:item.colorValue}})
    //   }
    // },
    toDetail(item,i){
      this.list1 = []
      if(item.choose){
        this.currentIndex = i
        this.currentSpuCode = item.spuCode
        this.currentColorValue = item.colorValue
        for(var i = 0;i<this.basicForm.sendOrderDetailList.length;i++){
          if(this.basicForm.sendOrderDetailList[i].spuCode == item.spuCode&&this.basicForm.sendOrderDetailList[i].colorValue == item.colorValue){
            this.list1.push(this.basicForm.sendOrderDetailList[i])
            this.pageType = 2
          }
        }
      }else{
        this.currentIndex = i
        this.currentSpuCode = item.spuCode
        this.currentColorValue = item.colorValue
        var queryParams = {
          "purchaseOrderId":this.basicForm.purchaseOrderId,
          "spuCode":item.spuCode,
          "colorCode":item.colorCode,
          // "spuCodeList":[this.arr[0].spuCode],
          "start":0,
          "size":30,
          "orderRules":[{"orderKey":"t1.spuCode","desc":false},{"orderKey":"t1.colorCode","desc":false}]
        };
        axiosApi.pagePurchaseOrderGoodsList(queryParams).then(response => {
          this.list1 = response.content.list;
          this.pageType = 2
          // this.$refs.commonTableRef2.reloadDone()
        }).catch(error => {
          // this.$refs.commonTableRef2.reloadDone()
        })
      }
    },
    changeTotal(item){
      if(item.sendSingleBoxNum&&item.sendCtn){
        item.sendGoodsNum = parseInt(item.sendSingleBoxNum*item.sendCtn)
        this.$set(item, 'sendGoodsNum', parseInt(item.sendSingleBoxNum*item.sendCtn))
        // item.sendGoodsNum =
        // console.log(item.sendGoodsNum)
      }
      var queryParams = {...item}
      axiosApi.updateSendOrderDetail(queryParams).then(response => {
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
      })
    },
    complete(){
      var num1 = 0;
      var num2 = 0;
      this.list1.forEach((item)=>{
        if(item.sendCtn){
          num1+=parseInt(item.sendCtn)
        }
        if(item.sendGoodsNum){
          num2+=parseInt(item.sendGoodsNum)
        }
      })
      if(this.list[this.currentIndex].choose){
        for(var i = 0;i<this.basicForm.sendOrderDetailList.length;i++){
          if(this.basicForm.sendOrderDetailList[i].spuCode == this.list1[0].spuCode&&this.basicForm.sendOrderDetailList[i].colorValue == this.list1[0].colorValue){
            this.basicForm.sendOrderDetailList.splice(i,1)
            i--
          }
        }
        this.basicForm.sendOrderDetailList= this.basicForm.sendOrderDetailList.concat(this.list1)
        for(var i = 0;i<this.basicForm.computedList.length;i++){
          if(this.basicForm.computedList[i].spuCode == this.list1[0].spuCode&&this.basicForm.computedList[i].colorValue == this.list1[0].colorValue){
            this.basicForm.computedList.splice(i,1)
            i--
          }
        }
        this.basicForm.computedList.push({spuCode:this.list1[0].spuCode,colorValue:this.list1[0].colorValue,sendColorCtn:num1,sendColorGoodsNum:num2})
      }else{
        this.basicForm.computedList.push({spuCode:this.list1[0].spuCode,colorValue:this.list1[0].colorValue,sendColorCtn:num1,sendColorGoodsNum:num2})
        this.basicForm.sendOrderDetailList= this.basicForm.sendOrderDetailList.concat(this.list1)
        this.list[this.currentIndex].choose = true
      }
      // if(this.list[this.currentIndex].choose){
      //   for(var i = 0;i<this.basicForm.sendOrderDetailList.length;i++){
      //     if(this.basicForm.sendOrderDetailList[i].spuCode == this.list1[0].spuCode&&this.basicForm.sendOrderDetailList[i].colorValue == this.list1[0].colorValue){
      //       this.basicForm.sendOrderDetailList.splice(i,1)
      //       i--
      //     }
      //   }
      //   this.basicForm.sendOrderDetailList= this.basicForm.sendOrderDetailList.concat(this.list1)
      //
      // }
      this.pageType=1
    },
    createSendOrder(){
      this.$refs.myForm.validate().then((valid) => {
        var queryParams = {...this.basicForm,webCreatePage:1}
        if(queryParams.sendTime){
          queryParams.sendTime = queryParams.sendTime+' 00:00:00'
        }
        if(this.basicForm.sendOrderId==''){
          queryParams.createPage = 1;
          axiosApi.createSendOrder(queryParams).then(response => {
            this.basicForm.sendOrderId = response.content.sendOrderId
            Toast.success('操作成功');
          }).catch(error => {
          })
        }else{
          axiosApi.updateSendOrder(queryParams).then(response => {
            Toast.success('操作成功');
          }).catch(error => {
          })
        }
      })
        .catch(() => {
          // on cancel
        });
    },
    onSubmit() {
      this.$refs.myForm.validate().then((valid) => {
        Dialog.confirm({
          title: '提示',
          message: '确认提交？',
        })
          .then(() => {
            var queryParams = {
              ...this.basicForm,
              webCreatePage:1
            };
            if(queryParams.sendTime){
              queryParams.sendTime = queryParams.sendTime+' 00:00:00'
            }
            axiosApi.updateSendOrder(queryParams).then(response => {
              var queryParams1 = {
                sendOrderId:this.basicForm.sendOrderId,
              };
              axiosApi.submitSendOrder(queryParams1).then(response => {
                Toast.success('操作成功');
                this.$router.push({name:'sendOrder'})
              }).catch(error => {
              })
            }).catch(error => {
            })
          })
          .catch(() => {
            // on cancel
          });
      })
        .catch(() => {
          // on cancel
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "createSendOrderDetail") {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  }
}



// WEBPACK FOOTER //
// ./src/pages/sendOrder/editSendOrder.vue